import { render, staticRenderFns } from "./History.vue?vue&type=template&id=a4f3499c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "History.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/History.vue
// module id = 2313
// module chunks = 1